var MultiSortOn = false;
var StartMulti = false; 

function CheckSort(TableName, List, Event, Element){
    
	$.getJSON('/MultiSortColumnList.php?TableName='+TableName, function(data)
	{
		if (data.length > 1)
		{
			MultiSortOn = true;
			StartMulti = true;
		}
		      
		LoadSort(List, TableName, Event, Element);                          
	});   
}   


function CreateSort(TableName, ListName)
{

	// Drag N Drop unique number needs to be reset to zero, or the left/right
	// arrows won't work if the Sort is reopened before browser reload
	if (typeof $.fn.drag_drop_selectable.unique != 'undefined')
	{
		$.fn.drag_drop_selectable.unique = 0;
	}

	$.fn.drag_drop_selectable
			.dragdraw('Available Columns', 'Selected Columns', '/MultiSortColumnList.php?&Available=0&TableName=' + TableName, '/MultiSortColumnList.php?TableName='
					+ TableName, 'Id', 'Name', 'Id', 'Name', 'holder', 'sort_access', true);

	$('#formbuttons').html("<input type='button' value='Save' name='save' id='save' onclick='SaveData(\"" + TableName + "\",\"" + ListName
			+ "\")'/><input type='button' name='Cancel' value='Cancel' id='close' NewOrder='' Key=''/>");

	var d = $("#dialogbox").dialog(
	{
		height : '440',
		width : '960',
		modal : true,
		open : function(event, ui)
		{
			// remove the scrollbar in chrome and FF
			$(this).css('overflow', 'hidden');
		}
	});
	$(".ui-dialog").css("zIndex", 10000);

	// IE has a height problem with windows that are closed and reopen. makes
	// sure the window is reopened with the proper height
	if ($.browser.msie)
	{
		$("#dialogbox").css("height","440px");
		$(".ui-dialog").css("height","440px");
		d.dialog("option", "position", "center");
	}

	$('#close').click(function()
	{
		$('#dialogbox').dialog('close');
	});
    
}
/**
 * The Save Button function on the sort modal dialog
 * 
 * @param string
 *            TableName The SQL table name
 * @param string
 *            ListName The name of the cList js element
 */
function SaveData(TableName, ListName)
{
	var remove = $('#remove').html();
	var add = $('#add').html();

	var SortColumnsAddList = new Array();
	var SortOrderList = new Array();

	var add_array = add.split(",");

	var i = 0;
	var a = 0;

	while (i < add_array.length)
	{
		SortColumnsAddList[a] = add_array[i++].substring(3);
		SortOrderList[a] = add_array[i++];

		++a;
	}

	var SortColumnsAddListString = SortColumnsAddList.join(",");
	var SortOrderListString = SortOrderList.join(",");

	var Element = document.getElementById('save');
	Element.setAttribute('Key', SortColumnsAddListString);
	Element.setAttribute('NewOrder', SortOrderListString);
	Element.setAttribute('cListName', ListName);

	var url_encode = 'FieldName=' + TableName + '&add=' + add + '&remove=' + remove;

	Ajax(
	{
		type : 'POST',
		url : '/MultiSortDoEdit.php',
		data : url_encode,
		success : function(data)
		{
			var result = ParseJson(data);
			if (result)
			{
				ColumnSortUpdate(null, Element);
				MultiSortOn = true;
				$('#dialogbox').dialog('close');
			}
		},
		error : function(XMLHttpRequest, textStatus, errorThrown)
		{
			alert('There was an error saving the Sort Columns');
		}
	});

}

/**
 * This function is called from list.js when a user clicks on a Column Header It
 * overwrites that table's saved sort order and turns the JS super global
 * variable MultiSortOn to false so future calls do not display a warning
 * message about clearing the sort
 * 
 * @param TableName The SQL table name
 * @param SortField The column that was clicked by the user
 * @param SortOrder The order of the column that was clicked by the user
 */
function SaveMultiSortColumnData(TableName, SortField, SortOrder)
{
	SortField = "SO-" + SortField;
	SortOrder = SortOrder;

	var add = SortField + "," + SortOrder;
	var url_encode = 'FieldName=' + TableName + '&add=' + add + '&remove=';

	Ajax(
	{
		type : 'POST',
		url : '/MultiSortDoEdit.php',
		data : url_encode,
		success : function(html)
		{
			MultiSortOn = false;
		}
	});
}
